import React from 'react';
import { Column, GridContainer, Row, tokensRaw, useScreenClass } from '@vp/swan';
import styled from 'styled-components';
import { BottomBar } from './BottomBar';
import { ProgressBar } from './ProgressBar';

const ShellInner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding: ${tokensRaw.SwanSemSpace8} 0px;
    min-width: 0;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`;

const CenteredColumn: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Column
        spanXs={12}
        spanSm={12}
        spanMd={12}
        offsetLg={2}
        offsetXl={3}
        offsetMd={0}
        span={6}
        spanLg={8}
    >
        {children}
    </Column>
);

export const StepLayout = ({
    children,
    NextAction,
    PreviousAction,
}: {
    children: React.ReactNode;
    NextAction?: React.ComponentType;
    PreviousAction?: React.ComponentType;
}) => {
    const screenClass = useScreenClass();
    return (
        <>
            <ShellInner>
                <GridContainer>
                    <Row>
                        <CenteredColumn>
                            {screenClass !== 'xs' && <ProgressBar />}
                            {children}
                        </CenteredColumn>
                    </Row>
                </GridContainer>
            </ShellInner>
            <BottomBar NextAction={NextAction} PreviousAction={PreviousAction} />
        </>
    );
};
